import styled from 'styled-components'
export const BlogAd = styled.div`
  width: 100%;
  padding: 24px;
  background: #000000;
  box-sizing: border-box;
  .BlogAd__Text {
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
    margin: 8px 0 16px 0;
  }
  .BlogAd__Img-Container {
    width: 100%;
    margin-bottom: 32px;
    overflow: hidden;
    position: relative;
    padding-bottom: 56.2%;

    .BlogAd__Img {
      position: absolute;
      object-fit: cover;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
`
